import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { useState } from 'react';
import { BillingDetailsCustomerEditForm } from '../billing-details-customer';
import { BillingDetailsPaymentEditForm } from '../billing-details-payment';

export function BillingDetailsEdit() {
  const [expanded, setExpanded] = useState<'billing' | 'payment'>('billing');

  return (
    <BillingDetailsEditContainer>
      <ExpandableContainer expanded={expanded === 'billing'}>
        <Heading
          clickable={expanded === 'payment'}
          onClick={() => setExpanded('billing')}
        >
          Billing details
        </Heading>
        <ContentWrapper>
          <Content>
            <BillingDetailsCustomerEditForm
              onSuccess={() => setExpanded('payment')}
            />
          </Content>
        </ContentWrapper>
      </ExpandableContainer>

      <ExpandableContainer expanded={expanded === 'payment'}>
        <Heading>Payment details</Heading>
        <ContentWrapper>
          <Content>
            <BillingDetailsPaymentEditForm />
          </Content>
        </ContentWrapper>
      </ExpandableContainer>
    </BillingDetailsEditContainer>
  );
}

const BillingDetailsEditContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ExpandableContainer = styled.div<{ expanded: boolean }>`
  display: grid;
  overflow: hidden;
  grid-template-columns: 100%;
  grid-template-rows: min-content ${({ expanded }) => (expanded ? '1fr' : '0')};
  transition: grid-template-rows 0.2s;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.purple[10]};
`;

const Heading = styled.h2<{ clickable?: boolean }>`
  padding: 16px 24px;
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.typography.colorPrimary};

  ${({ clickable, theme }) =>
    clickable &&
    css`
      cursor: pointer;
      :hover {
        background: ${theme.colors.purple[5]};
      }
    `}
`;

const ContentWrapper = styled.div`
  min-height: 0;
`;

const Content = styled.div`
  color: ${({ theme }) => theme.colors.purple[100]};
  padding: 8px 24px 16px;
`;
